import React, { PropsWithChildren } from 'react';

type LoginLayoutProps = PropsWithChildren<{}>;

const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  return (
    <div className="App flex h-[100vh] justify-center items-center bg-backgroundGrey">
      {children}
    </div>
  );
};

export default LoginLayout;
